import styled from 'styled-components'

const Grid = styled.div`
  // display: flex;
  // flex-flow: row wrap;
  // align-items: center;
  // justify-content: space-between;
  //
  // margin: -${props => props.theme.gutter / 2}px;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 400px;
  grid-auto-rows: 400px;
  grid-gap: .2em;
  width: 100%;

  position: relative;
`

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid.js